export default __webpack_public_path__ + "static/media/insta.b2f57dc0.svg";